// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lLcOT","overlay":"Modal_overlay__UJat6","container":"Modal_container__nRkN7"};